export const headers = [
  { field: 'id', headerName: 'ID', width: 90, hide: true },
  { field: 'ac_id_padre', headerName: 'ID Padre', width: 150, hide: true },
  { field: 'ac_id_hijo', headerName: 'ID Hijo', width: 150, hide: true },
  { field: 'ac_codigo_hijo', headerName: 'Codigo', width: 150 },
  { field: 'art_descripcion', headerName: 'Descripción', width: 300 }, // Columna para la descripción
  { field: 'ac_cantidad', headerName: 'Cantidad', width: 150 },
];
